import React from 'react';
export default class Example extends React.Component {
    render() {
        return (<div>
                <div className="pb-0" style={{
                backgroundColor: '#488484',
            }}>
                    pb-0
                </div>
                <div className="pb-1" style={{
                backgroundColor: '#099332',
            }}>
                    pb-1
                </div>
                <div className="pb-2" style={{
                backgroundColor: '#3498db',
            }}>
                    pb-2
                </div>
                <div className="pb-3" style={{
                backgroundColor: '#27ae60',
            }}>
                    pb-3
                </div>
                <div className="pb-4" style={{
                backgroundColor: '#2c3e50',
            }}>
                    pb-4
                </div>
                <div className="pb-5" style={{
                backgroundColor: '#e74c3c',
            }}>
                    pb-5
                </div>
                <div className="pb-6" style={{
                backgroundColor: '#ff9900',
            }}>
                    pb-6
                </div>
                <div className="pb-7" style={{
                backgroundColor: '#9b59b6',
            }}>
                    pb-7
                </div>
                <div className="pb-8" style={{
                backgroundColor: '#f1c40f',
            }}>
                    pb-8
                </div>
                <div className="pb-9" style={{
                backgroundColor: '#2ecc71',
            }}>
                    pb-9
                </div>
                <div className="pb-10" style={{
                backgroundColor: '#2980b9',
            }}>
                    pb-10
                </div>
                <div className="pb-11" style={{
                backgroundColor: '#e74c3c',
            }}>
                    pb-11
                </div>
                <div className="pb-12" style={{
                backgroundColor: '#8e44ad',
            }}>
                    pb-12
                </div>
            </div>);
    }
}
